<template>
  <div id="loginBottom" :class="{mobile: isMobile}">
    <div>
      <a href="javascript:void(0)" @click="setLocale('fr')" v-if="$ts.state.locale === 'en'">Français</a>
      <a href="javascript:void(0)" @click="setLocale('en')" v-if="$ts.state.locale === 'fr'">English</a>
      <span class="separator">|</span>
      <template v-if="!isMobile">
        <a :href="aboutUrl" target="_blank">{{$t("advanced_navigation.about")}}</a>
        <span class="separator">|</span>
        <a :href="contactUsUrl" target="_blank">{{$t("advanced_navigation.contact")}}</a>
      </template>
      <template v-if="isMobile">
        <a href="javascript:void(0)">© {{ (new Date()).getFullYear() }} iShopFood</a>
      </template>
    </div>
    <div v-if="!isMobile">
      <a href="javascript:void(0)">© {{ (new Date()).getFullYear() }} iShopFood</a>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: "LoginBottom",

    computed: {
      aboutUrl() {
        return `https://ishopfood.com/restaurant/${this.$ts.state.locale === 'fr' ? '' : this.$ts.state.locale}`
      },

      contactUsUrl() {
        if(this.$ts.state.locale === 'fr') {
          return "https://ishopfood.com/restaurant/nous-joindre/"
        } else {
          return "https://ishopfood.com/restaurant/en/contact-us/"
        }
      },

      isMobile() {
        return this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md';
      }
    },
    methods: {
      setLocale(language) {
        this.$ts.commit("setLocale", language);
      }
    }
  };
</script>

<style lang="scss" scoped>

#loginBottom {
  font-size: 14px;
  color: #808080;
  text-align: center;
  padding-bottom: 40px;
  a {
    color: #808080;
    text-decoration: none;

    &.active {
      font-weight: bold;
    }
  }
  div:first-of-type {
    margin-bottom: 20px;
  }
  .separator {
    margin: 0 10px;
    color: #bfbfbf;
  }

  &.mobile {
    position: fixed;
    bottom: 5px;
    left: 0;
    right: 0;
    padding-bottom: 5px;
    font-size: 12px;

    div:first-of-type {
      margin-bottom: 0;

      a {
        padding: 5px 0;
        display: inline-block;
      }
    }
  }
}

</style>
